function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { getColor } from '../../theme-tools';
import { asMultiStyleConfig } from '../../utils/theme';
var size = {
  md: {
    fontSize: 'md',
    height: 11,
    px: 2,
    borderRadius: 'lg'
  }
};
export var getDefaults = _ref => {
  var {
    focusBorderColor = 'blue.400',
    errorBorderColor = 'red.700',
    focusBoxShadowColor = 'blue.300',
    errorBoxShadowColor = errorBorderColor
  } = _ref;
  return {
    focusBorderColor,
    errorBorderColor,
    focusBoxShadowColor,
    errorBoxShadowColor
  };
};
var getContainerStyles = () => {
  return {
    borderRadius: 'lg',
    width: '100%',
    display: 'flex',
    position: 'relative',
    transition: 'all 0.2s'
  };
};
var getVariantOutline = props => {
  var {
    theme
  } = props;
  var {
    focusBorderColor,
    errorBorderColor,
    focusBoxShadowColor,
    errorBoxShadowColor
  } = getDefaults(props);
  return {
    field: {
      border: '1px solid',
      borderColor: 'grey.500',
      bg: 'white',
      px: 4,
      py: 2,
      _placeholder: {
        color: '#6D6D6D'
      },
      _readOnly: {
        boxShadow: 'none !important',
        userSelect: 'all'
      },
      _disabled: {
        bg: '#F0F0F0',
        color: '#6D6D6D',
        borderColor: 'grey.400',
        cursor: 'not-allowed'
      },
      _focus: {
        zIndex: 1,
        borderColor: getColor(theme, focusBorderColor),
        boxShadow: "0 0 4px 1px ".concat(getColor(theme, focusBoxShadowColor))
      },
      _invalid: {
        borderColor: getColor(theme, errorBorderColor),
        boxShadow: "0 0 4px 1px ".concat(getColor(theme, errorBoxShadowColor))
      }
    },
    addon: {
      border: 'none',
      bg: 'grey.100'
    }
  };
};
var parts = ['container', 'field', 'addon'];
var defaultProps = {
  size: 'md',
  variant: 'outline'
};
var baseStyle = () => ({
  container: getContainerStyles(),
  field: {
    width: '100%',
    minWidth: 0,
    outline: 0,
    position: 'relative',
    appearance: 'none',
    transition: 'all 0.2s'
  }
});
export var sizes = {
  md: {
    field: size.md,
    addon: _objectSpread(_objectSpread({}, size.md), {}, {
      size: size.md.height,
      minWidth: 11
    })
  }
};
var variants = {
  outline: getVariantOutline
};
export default asMultiStyleConfig({
  parts,
  baseStyle,
  sizes,
  variants,
  defaultProps
});